import DocPageLayout from './DocPageLayout.js';
import { HealingOutlined, EmojiObjectsOutlined } from '@mui/icons-material';
import './DocPage.css';

const heroImage = '/img/nerve-therapy-trial.webp';

const symptomSections = [
    {
        icon: EmojiObjectsOutlined,
        title: '当院の肩コリ・五十肩の施術の方法とは？',
        description: [
            '院の肩コリ・五十肩施術は、痛みが生じている箇所のみにアプローチする施術は行いません。',
            '当院の施術方法は、'
        ],
        steps: [
            '肩コリ・五十肩の原因となっている筋肉が硬くなっている箇所（筋肉、筋膜）を徹底的な検査と問診によって究明致します。',
            '次に硬くなった筋肉、筋膜に対して当院独自の全身の筋肉、筋膜、骨盤のバランスを整えます。',
            '再発防止のため体の使い方を見ていきます。'
        ]
    },
    {
        icon: HealingOutlined,
        title: 'このまま肩コリ・五十肩を放っておくと',
        description: [
            '腕が完全に上がらなくなったり',
            '夜に肩が疼いて寝れなくなったり',
            '握力がなくなって手や腕や首を動かせなくなるという事もございます',
            '軽い肩コリ・五十肩だから・・・',
            '放っていたら肩コリ・五十肩は治るだろう・・・とかは、大きな間違いです。'
        ]
    }
];

const SymptomShoulderPain = () => (
    <DocPageLayout
        currentRoute="/symptoms/shoulder-pain"
        pageLabel="肩こり・五十肩"
        pageTitle="肩コリ・五十肩"
        heroImage={heroImage}
        heroImageAlt="肩こりに悩む方"
        heroHighlight="肩こり・五十肩は、なぜ起こるの？"
        heroDescription={[
            '◆肩コリ・五十肩',
            '「肩コリ」と「五十肩」は共に同じ肩周辺に起こる症状ですが肩コリの多くは「筋肉の血行不良」によって引き起こされます。',
            '血行不良になる事には、姿勢が悪い状態で長時間デスクワークをする、精神的な緊張で筋肉が硬くなっている、手、腕の疲労によるものなどがあります。',
            '五十肩の原因は肩の関節、関節周囲の靭帯・筋・関節包が炎症や拘縮を起こすからとされています。',
            'その他にも症状を引き起こす原因としては、肩、背中の筋肉を動かさない事が多い、腕を上げる事の多い作業をよくするなどがあります。',
        ]}
    >
        {symptomSections.map(({ icon: Icon, title, description, steps }) => (
            <article key={title} className="doc-section">
                <h3 className="doc-section__title">
                    <Icon className="doc-section__icon" />
                    {title}
                </h3>
                <div className="doc-section__body">
                    {description &&
                        description.map((text, index) => (
                            <p key={`${title}-description-${index}`}>{text}</p>
                        ))}
                    {steps && (
                        <ol className="doc-ordered-list">
                            {steps.map((step, index) => (
                                <li key={`${title}-step-${index}`}>{step}</li>
                            ))}
                        </ol>
                    )}
                </div>
            </article>
        ))}
        <p className="doc-final-note">当院の、腰痛施術を受けて頂くことをお勧めします。</p>
        <div className="doc-page__cta">
            <a
                className="doc-reservation-button"
                href="https://book.squareup.com/appointments/hqjlguwjlxeenh/location/MH09XMWCMM5H9/services"
                target="_blank"
                rel="noopener noreferrer"
            >
                ご予約はこちら
            </a>
        </div>
    </DocPageLayout>
);

export default SymptomShoulderPain;
